import { render, staticRenderFns } from "./JFileManager.vue?vue&type=template&id=bfd2c01a&"
import script from "./JFileManager.vue?vue&type=script&lang=js&"
export * from "./JFileManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports